import { validateRegistry } from '@unified-governance/shared';
import type { RemoteRegistry } from '@unified-governance/shared';

export async function fetchRegistry(): Promise<RemoteRegistry> {
  const response = await fetch('/remotes.json', { cache: 'no-cache' });
  if (!response.ok) {
    throw new Error(`Failed to load remotes.json: ${response.status}`);
  }
  const data: unknown = await response.json();
  const result = validateRegistry(data);
  if (!result.ok || !result.value) {
    throw new Error(`Invalid remotes.json: ${result.errors.join('; ')}`);
  }
  return result.value;
}
